import axios from "axios";
import config from "../../../config/config";
import {GetToken} from "../../consultForm/Requests/movistar";

//////////////////////////////////
// UPDATE CARTS AMOUNTS :::::::
export const UPDATE_CART_AMOUNT = async (data:any, filial:number)=>{
    let obj:any={result:false}

    let token = await GetToken();

    let dominios:any = {
        1:config.REACT_APP_MOVISTAR_DOMINIO_RECAUDO,
        2:config.REACT_APP_TELEBUCARAMANGA_DOMINIO,
        3:config.REACT_APP_METROTEL_DOMINIO
    }

    let publicKey:any= {
        1:config.REACT_APP_MOVISTAR_RECAUDO_PUBLIC_KEY,
        2:config.REACT_APP_TELEBUCARAMANGA_RECAUDO_PUBLIC_KEY,
        3:config.REACT_APP_METROTEL_RECAUDO_PUBLIC_KEY,
    }

    try{
        await axios({
            method:'POST',
            url:config.UPDATE_CART_VALUES,
            data:{
                'dominio': dominios[filial],
                'ultraFacturas':data.ultraFacturas,
                'public_key':publicKey[filial]
            },
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then((result:any)=>{
                if(result.data.data === 1407){
                    obj.result   = false
                    obj.timeout  = true
                    obj.message  = 'Time out!'
                    return obj;
                }
                if(result.data && result.status == 200){
                    obj.result = result.data.success
                }
            })
            .catch((e:any)=>{
                obj.result = false
            })

    }
    catch(e){
        obj.result = false;
    }


    return obj;
}